/* PACO HERRERO · componentes de las secciones PH (slider y carruseles) */
if (!customElements.get('ph-slider')) {
  class PhSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ph-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.track = this.querySelector('.ph-hero__track');
      this.section = this.closest('.ph-hero');
      this.isSlide = this.section && this.section.classList.contains('ph-hero--slide');
      this.index = 0;
      this.interval = (parseFloat(this.dataset.interval) || 6) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.userPaused = this.reduced;
      this.pauseBtn = this.querySelector('[data-pause]');

      this.addEventListener('click', (e) => {
        const go = e.target.closest('[data-go]');
        if (go) return this.goTo(parseInt(go.dataset.go, 10), true);
        if (e.target.closest('[data-prev]')) return this.goTo(this.index - 1, true);
        if (e.target.closest('[data-next]')) return this.goTo(this.index + 1, true);
        if (e.target.closest('[data-pause]')) return this.togglePause();
        if (e.target.closest('[data-scroll-next]')) {
          const host = this.closest('.shopify-section') || this;
          window.scrollTo({ top: host.getBoundingClientRect().bottom + window.scrollY, behavior: this.reduced ? 'auto' : 'smooth' });
        }
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.goTo(this.index - 1, true);
        if (e.key === 'ArrowRight') this.goTo(this.index + 1, true);
      });

      let startX = null;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) this.goTo(this.index + (dx < 0 ? 1 : -1), true);
        startX = null;
      });

      this.addEventListener('mouseenter', () => { this.hover = true; this.stop(); });
      this.addEventListener('mouseleave', () => { this.hover = false; this.start(); });
      this.addEventListener('focusin', () => { this.hover = true; this.stop(); });
      this.addEventListener('focusout', () => { this.hover = false; this.start(); });
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.visible ? this.start() : this.stop();
        }, { threshold: 0.25 });
        this.io.observe(this);
      } else {
        this.visible = true;
      }

      if (this.userPaused && this.pauseBtn) this.setPausedUi(true);

      document.addEventListener('shopify:block:select', this.onBlockSelect = (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i > -1) { this.userPaused = true; this.stop(); this.goTo(i); }
      });
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect = () => {
        this.userPaused = this.reduced; this.start();
      });
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    goTo(i, fromUser) {
      const n = this.slides.length;
      if (!n) return;
      this.index = (i + n) % n;
      this.slides.forEach((s, k) => {
        const active = k === this.index;
        s.classList.toggle('is-active', active);
        if (active) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
        const v = s.querySelector('video');
        if (v) { active ? v.play().catch(() => {}) : v.pause(); }
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
      const counter = this.querySelector('[data-current]');
      if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
      if (this.isSlide) this.track.style.transform = 'translateX(' + (-100 * this.index) + '%)';
      if (fromUser) this.restart();
    }

    start() {
      if (!this.autoplay || this.userPaused || this.hover || this.visible === false || this.timer) return;
      this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }

    togglePause() {
      this.userPaused = !this.userPaused;
      this.setPausedUi(this.userPaused);
      this.userPaused ? this.stop() : this.start();
    }
    setPausedUi(paused) {
      if (!this.pauseBtn) return;
      this.pauseBtn.classList.toggle('is-paused', paused);
      this.pauseBtn.setAttribute('aria-label', paused ? 'Reanudar el pase de diapositivas' : 'Pausar el pase de diapositivas');
    }
  }
  customElements.define('ph-slider', PhSlider);
}

if (!customElements.get('ph-carousel')) {
  class PhCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ph-pc__track, [data-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-dir="-1"]');
      this.next = this.querySelector('[data-dir="1"]');
      this.bar = this.querySelector('.ph-pc__progress');
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-dir]');
        if (!b) return;
        const item = this.track.querySelector(':scope > *');
        const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
        const per = Math.max(1, Math.floor(this.track.clientWidth / step));
        this.track.scrollBy({ left: parseInt(b.dataset.dir, 10) * step * per, behavior: 'smooth' });
      });
      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }
    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      if (this.bar) {
        const w = Math.min(100, (t.clientWidth / t.scrollWidth) * 100);
        const x = max > 0 ? (t.scrollLeft / max) * (100 / w * 100 - 100) : 0;
        this.bar.style.setProperty('--ph-pc-progress-w', w + '%');
        this.bar.style.setProperty('--ph-pc-progress-x', x + '%');
      }
    }
  }
  customElements.define('ph-carousel', PhCarousel);
}

/* Aparición suave al hacer scroll.
   Solo se activa si el visitante no ha pedido reducir el movimiento y nunca
   dentro del editor de Shopify, para que allí todo se vea siempre. */
(function () {
  if (window.__phReveal) return;
  window.__phReveal = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = window.Shopify && window.Shopify.designMode;
  if (reduce || design || !('IntersectionObserver' in window)) return;

  const SELECTOR = [
    '.ph-pc__head', '.ph-pc__item', '.ph-tile', '.ph-tiles__head',
    '.ph-brand__head', '.ph-brand__body', '.ph-ed__intro', '.ph-ed__item',
    '.ph-ph__text', '.ph-ph__media', '.ph-mt__figure', '.ph-mt__text',
    '.ph-fl__head', '.ph-fl__figure', '.ph-fl__item', '.ph-stats__item',
    '.ph-cmp__col', '.ph-faq__item', '.ph-cta__inner', '.ph-strip__figure',
    '.ph-strip__title', '.ph-ft__col'
  ].join(',');

  document.documentElement.classList.add('ph-anim');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const t = entry.target;
      if (t.dataset.phGroup) {
        t.querySelectorAll(':scope > [data-ph-reveal]').forEach((c) => c.classList.add('is-inview'));
      } else {
        t.classList.add('is-inview');
      }
      io.unobserve(t);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  const scan = (root) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.dataset.phReveal) return;
      el.dataset.phReveal = '1';
      const siblings = Array.from(el.parentElement ? el.parentElement.children : []).filter((n) => n.matches(SELECTOR));
      const i = Math.max(0, siblings.indexOf(el));
      el.style.setProperty('--ph-delay', Math.min(i, 6) * 90 + 'ms');
      // Las tarjetas de un carrusel aparecen todas juntas cuando se ve el carrusel
      const track = el.matches('.ph-pc__item, .ph-ed__item') ? el.parentElement : null;
      if (track) {
        if (!track.dataset.phGroup) { track.dataset.phGroup = '1'; io.observe(track); }
      } else {
        io.observe(el);
      }
    });
  };
  const start = () => scan(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // Red de seguridad: muestra lo que ya esté en pantalla tras la carga
  window.addEventListener('load', () => setTimeout(() => {
    document.querySelectorAll('[data-ph-reveal]:not(.is-inview)').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-inview');
    });
  }, 1500));
})();
